import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './key-strength-development-area-print.module.scss';
import { TEXT_LABEL } from '../../../TalentSketch/constants';
import { TP_PRINT_SECTION_NAME } from '../../constants';
import { Divider } from 'antd';

const KeyStrengthDevelopmentAreaPrint = ({ fetchedData }) => {
  const [keyStrengthPills, setKeyStrengthPills] = useState([]);
  const [developmentAreasPills, setDevelopmentAreasPills] = useState([]);
  const [keyStrengthList, setKeyStrengthList] = useState([]);
  const [developmentAreasList, setDevelopmentAreasList] = useState([]);

  const handleSetDataPrint = (resData) => {
    setKeyStrengthPills(resData.keyStrengthPills);
    setDevelopmentAreasPills(resData.developmentAreasPills);
    setKeyStrengthList(resData.keyStrengthList);
    setDevelopmentAreasList(resData.developmentAreasList);
  };

  useEffect(() => {
    if (!fetchedData) return;
    handleSetDataPrint(fetchedData);
  }, [fetchedData]);
  return (
    <div className={styles.printWrapContent}>
      <div className={styles.wrapper} data-print-section={TP_PRINT_SECTION_NAME.KEY_STRENGTHS}>
        <div className={styles.title}>{TEXT_LABEL.KEY_STRENGTH}</div>
        <div className={styles.list}>
          {keyStrengthPills.map((item, index) => (
            <div className={styles.item} key={index}>
              {item.attribute}
            </div>
          ))}
        </div>
        <Divider />
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>
                  <h3>Key Strength Remarks</h3>
                </th>
              </tr>
            </thead>
            <tbody>
              {keyStrengthList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <div className={styles.content}>
                        <p className="mb-2">{item?.attribute_evidences || ''}</p>
                        <p className={styles.source}>
                          {item?.attribute_evidences && `${item.document ? `${item.document}, ` : ''} ${item.doc_year} (${item.source})`}
                        </p>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.wrapper} data-print-section={TP_PRINT_SECTION_NAME.DEVELOPMENT_AREAS}>
        <div className={styles.title}>{TEXT_LABEL.DEVELOPMENT_AREA}</div>
        <div className={styles.list}>
          {developmentAreasPills.map((item, index) => (
            <div className={styles.item} key={index}>
              {item.attribute}
            </div>
          ))}
        </div>
        <Divider />
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>
                  <h3>Development Area Remarks</h3>
                </th>
              </tr>
            </thead>
            <tbody>
              {developmentAreasList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <div className={styles.content}>
                        <p className="mb-2">{item?.attribute_evidences || ''}</p>
                        <p className={styles.source}>
                          {item?.attribute_evidences && `${item.document ? `${item.document}, ` : ''} ${item.doc_year} (${item.source})`}
                        </p>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default KeyStrengthDevelopmentAreaPrint;

KeyStrengthDevelopmentAreaPrint.propTypes = {
  fetchedData: PropTypes.object,
};
